(() => {
  const NUMBER = /[+\u2212-]?\d[\d.,]*/;
  const DURATION = 900;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const format = (value, sample) => {
    const sign = sample.match(/^[+\u2212-]/);
    const grouped = sample.includes(',');
    const digits = grouped ? value.toLocaleString('en-US') : String(value);
    return sign ? sign[0] + digits : digits;
  };

  const wrap = (heading) => {
    const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const match = node.nodeValue.match(NUMBER);
      if (!match) continue;

      const target = parseInt(match[0].replace(/,/g, ''), 10);
      if (!Number.isFinite(target) || target < 10) continue;

      const after = node.splitText(match.index);
      after.splitText(match[0].length);

      const span = document.createElement('span');
      span.className = 'product-social-proof__count';
      span.textContent = match[0];
      after.parentNode.replaceChild(span, after);

      span.style.display = 'inline-block';
      span.style.textAlign = 'left';
      const pin = () => {
        const shown = span.textContent;
        span.textContent = match[0];
        span.style.minWidth = '';
        span.style.minWidth = `${span.getBoundingClientRect().width}px`;
        span.textContent = shown;
      };
      pin();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(pin);
      }

      return { span, target, sample: match[0] };
    }
    return null;
  };

  const run = ({ span, target, sample }) => {
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min((now - start) / DURATION, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      span.textContent = format(Math.round(target * eased), sample);
      if (t < 1) requestAnimationFrame(tick);
    };
    span.textContent = format(0, sample);
    requestAnimationFrame(tick);
  };

  const init = () => {
    const headings = document.querySelectorAll('.product-social-proof__heading');

    headings.forEach((heading) => {
      if (heading.dataset.countReady) return;
      heading.dataset.countReady = 'true';

      const found = wrap(heading);
      if (!found || reduced) return;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            run(found);
          });
        },
        { threshold: 0.6 }
      );
      observer.observe(heading);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
